<template>
  <!-- 行业活动信息 -->
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('industryReport.hdxxName') }}</span>
    </div>
    <el-form
      class="common_form"
      label-position="left"
      ref="activityInfoForm"
      :rules="rules"
      label-width="174px"
      :model="formData"
    >
      <el-row>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="formData.marketingForm === '2' ? $t('industryReport.hdxx.yxzt') : $t('industryReport.hdxx.hdmc')"
            prop="activityName"
          >
            <el-input
              :placeholder="formData.marketingForm === '2' ? $t('industryReport.hdxxtsy.yxzt') : $t('industryReport.hdxxtsy.hdmc')"
              v-model="formData.activityName"
              maxlength="200"
              :disabled="isReadOnly"
            />
          </el-form-item>
        </el-col>
        <!-- 业务单元 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="salerData.belongToQyw && unitNameList.length > 0"
                :key="'businessUnit'"
        >
          <el-form-item
            :label="$t('industryReport.hdxx.ywdy')"
            prop="businessUnitDisplayed"
            :required="salerData.belongToQyw && unitNameList.length > 0"
          >
            <el-select
              v-model="formData.businessUnitDisplayed"
              multiple
              collapse-tags
              placeholder
              :disabled="isReadOnly"
            >
              <el-option v-for="item in unitNameList" :key="item.id" :label="item.unitName" :value="item.unitName" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 营销形式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" :key="'marketingForm'">
          <el-form-item
            :label="$t('industryReport.hdxx.yxxs')"
            prop="marketingForm"
          >
            <el-select
              v-model="formData.marketingForm"
              :placeholder="$t('industryReport.hdxxtsy.yxxs')"
              @change="marketingFormChange"
              :disabled="isReadOnly || $route.path === '/editIndustryReportApplication'"
            >
              <el-option
                v-for="item in marketingFormList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动分类 -->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.hdfl')"
            prop="activityClassificationCode"
          >
            <el-select
              v-model="formData.activityClassificationCode"
              :placeholder="$t('industryReport.hdxxtsy.hdfl')"
              @change="activityClassificationCodeChange"
              :disabled="isReadOnly || $route.path === '/editIndustryReportApplication'"
            >
              <el-option
                v-for="item in activityClassificationList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动形式 -->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.hdxs')"
            prop="activityForms"
          >
            <el-select
              v-model="formData.activityForms"
              :placeholder="$t('industryReport.hdxxtsy.hdxs')"
              :disabled="isReadOnly"
            >
              <el-option
                v-for="item in activityFormsList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主办方-->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.zbf')"
            prop="organizer"
          >
            <el-select
              v-model="formData.organizer"
              :placeholder="$t('industryReport.hdxxtsy.zbf')"
              :disabled="isReadOnly"
            >
              <el-option
                v-for="item in organizerList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主要目标对象 -->
        <el-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <el-form-item
            :label="$t('industryReport.hdxx.zymbdx')"
            prop="targetObject"
          >
            <el-select
              v-model="formData.targetObject"
              :placeholder="$t('industryReport.hdxxtsy.zymbdx')"
              :disabled="isReadOnly"
              @change="targetObjectChange"
            >
              <el-option
                v-for="item in filteredTargetObjectList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主要目标对象-其它内容 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="isTargetObjectOther">
          <el-form-item :label="$t('newApp.activityInfo.otherTargetObject')" prop="targetObjectOther" :rules="[{ required: true, message: $t('newApp.activityInfo.otherTargetObjectP'), trigger: 'blur' }]">
            <el-input v-model="formData.targetObjectOther" :placeholder="$t('newApp.activityInfo.otherTargetObjectP')" :maxlength="200" :disabled="isReadOnly" />
          </el-form-item>
        </el-col>
        <!-- 目标覆盖客户画像 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.mbfgkhhx')"
            prop="targetCoverageCustomerPortrait"
          >
            <el-input
              v-model="formData.targetCoverageCustomerPortrait"
              maxlength="200"
              :placeholder="$t('industryReport.hdxxtsy.mbfgghhx')"
              :disabled="isReadOnly"
            />
          </el-form-item>
        </el-col>
        <!-- 邀请方-->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.yqf')"
            prop="invitingParty"
          >
            <el-select
              v-model="formData.invitingParty"
              :placeholder="$t('industryReport.hdxxtsy.yqf')"
              :disabled="isReadOnly || formData.activityClassificationCode === 'AC_01'"
            >
              <el-option
                v-for="item in invitingPartyList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 品推支持 -->
        <!-- 品推支持在数字营销和部分市场活动分类下显示 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="isPtShow">
          <el-form-item :label="$t('newApp.activityInfo.ps')" prop="brandPromotionSupport">
            <el-select
              v-model="formData.brandPromotionSupport"
              :disabled="isReadOnly"
              :placeholder="$t('newApp.activityInfo.psps')"
              @change="brandPromotionSupportChange"
            >
              <el-option
                v-for="item in brandPromotionSupporList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 关键市场 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.gjsc')"
            prop="keyMarket"
          >
            <el-input
              v-model="formData.keyMarket"
              maxlength="200"
              :placeholder="$t('industryReport.hdxxtsy.gjsc')"
              :disabled="isReadOnly"
            />
          </el-form-item>
        </el-col>
        <!-- 举办城市 -->
        <el-col v-if="formData.marketingForm === '1' && formData.activityClassificationCode !== 'AC_01'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.jbcs')"
            prop="city"
          >
            <el-input
              v-model="formData.city"
              maxlength="50"
              :placeholder="$t('industryReport.hdxxtsy.jbcs')"
              :disabled="isReadOnly"
            />
          </el-form-item>
        </el-col>
        <!-- 是否面向全国发布-->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.mxqgfb')"
            prop="isNationalRelease"
          >
            <el-select
              v-model="formData.isNationalRelease"
              :placeholder="$t('industryReport.hdxxtsy.mxqgfb')"
              @change="keyAttendeesChange"
              :disabled="isReadOnly"
            >
              <el-option
                v-for="item in isNationalReleaseList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 面向行业-->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.mxhy')"
            prop="targetIndustry"
          >
            <el-select
              v-model="formData.targetIndustry"
              :placeholder="$t('industryReport.hdxxtsy.mxhy')"
              :disabled="isReadOnly"
            >
              <el-option
                v-for="item in targetIndustryList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 预计举办周期-->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.yjjbzq')"
            prop="expectedDurationOfTheEvent"
          >
            <el-date-picker
              v-model="formData.expectedDurationOfTheEvent"
              class="activityDatePicker"
              style="width: 100%;"
              size="small"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleDateChange"
            />
          </el-form-item>
        </el-col>
        <!-- 活动工具包 -->
        <el-col v-if="formData.marketingForm === '1'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('industryReport.hdxx.hdgjb')"
            prop="activityToolkit"
          >
            <el-input
              v-model="formData.activityToolkit"
              :placeholder="$t('industryReport.hdxxtsy.hdgjb')"
              :disabled="isReadOnly"
            />
          </el-form-item>
        </el-col>
        <!-- 关键举措 -->
        <el-col v-if="formData.marketingForm === '1'" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item
            :label="$t('industryReport.hdxx.gjjc')"
            prop="cruxCheckbox"
            class="multistage"
          >
            <el-row>
              <el-col
                :span="24"
                class="cruxCustomStyle"
                :class="formData.cruxCheckbox.length > 0 ? 'borderStyle' : ''"
              >
                <div>
                  <el-checkbox-group
                    v-model="formData.cruxCheckbox"
                    @change="cruxCheckboxChange"
                  >
                    <template v-for="item in cruxCheckboxList">
                      <el-checkbox :key="item.key" :label="item.key" name="cruxCheckbox" v-if="item.disabled()">
                        {{ $t(`newApp.activityInfo.${item.value}`) }}
                      </el-checkbox>
                    </template>
                  </el-checkbox-group>
                </div>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('remotePoc') > -1">
                <el-form-item :label="$t('newApp.activityInfo.rpn')" prop="remotePoc">
                  <el-input v-model="formData.remotePoc" maxlength="150" :disabled="isReadOnly" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('unitedDiamondActivity') > -1">
                <el-form-item :label="$t('newApp.activityInfo.nofd')" prop="unitedDiamondActivity">
                  <el-input
                    v-model="formData.unitedDiamondActivity"
                    maxlength="150"
                    :disabled="isReadOnly"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('circleActivity') > -1">
                <el-form-item
                  :label="$t('newApp.activityInfo.noc')"
                  prop="circleActivity"
                >
                  <el-input
                    v-model="formData.circleActivity"
                    maxlength="150"
                    :disabled="isReadOnly"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('templateVisit') > -1">
                <el-form-item
                  :label="$t('newApp.activityInfo.tn')"
                  prop="templateVisit"
                >
                  <el-input
                    v-model="formData.templateVisit"
                    maxlength="150"
                    :disabled="isReadOnly"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('machineDemo') > -1">
                <el-form-item
                  :label="$t('newApp.activityInfo.machineDemo')"
                  prop="machineDemo"
                >
                  <el-input
                    v-model="formData.machineDemo"
                    maxlength="150"
                    :disabled="isReadOnly"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <!-- 活动内容涉及产品线 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <ProductLineSelect
            ref="productLineSelectRef"
            v-model="formData.productlineSupplement"
            :productline-supplement-list="productlineSupplementList"
            :disabled="isReadOnly"
            :read-only="isReadOnly"
            :read-only-text="formData.productlineView"
            :show-other-input="false"
            :activity-code="formData.activityCode"
            :report-type="0"
          />
        </el-col>
        <!-- 战略产品 -->
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          v-if="salerData.belongToQyw && lang === 'zh-CN'"
        >
          <el-form-item
            :label="comscValue"
            class="folding"
            prop="communicationScenarioList"
          >
            <template>
              <el-checkbox-group
                v-model="formData.communicationScenarioList"
                @change="productlineSupplementChange($event)"
              >
                <el-checkbox
                  v-for="item in fbCommunicationScenarioNew"
                  :key="item.fieldKey"
                  :label="item.fieldValue"
                  name="productlineSupplementType"
                >
                  {{ item.fieldValue }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </el-form-item>
        </el-col>
        <!-- 活动背景&目的 -->
        <el-col v-if="formData.marketingForm === '1'" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('newApp.activityInfo.ActivityBgA')" class="folding" prop="activityBackgroundPurpose">
            <template>
              <el-input type="textarea" v-model.trim="formData.activityBackgroundPurpose" :disabled="isReadOnly && !isFilterFields('activityBackgroundPurpose')"
                        placeholder="请填写定性目标【预邀请客户数及主要客户名称】、定量目标【预计3个月内新建业务机会数及金额、预计3个月内推动业务机会数及金额】" maxlength="1000" show-word-limit
              />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import { activityBaseApi } from '@/views/backStageManagement/service';
import { mapState } from 'vuex';
import { isNotEmpty, arrayQuery } from '@/utils/utils';
import { bus } from '@/utils/bus';
import targetObjectMixin from '../../mixins/targetObjectMixin';
import ProductLineSelect from './ProductLineSelect.vue';
export default {
  components: { ProductLineSelect },
  mixins: [targetObjectMixin],
  data () {
    let unionChannelTypeMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1 && this.salerData.belongToSmb) {
        callback(new Error(`${this.$t('newApp.activityInfo.pscst')}`));
      } else {
        callback();
      }
    };
    let unionChannelNameMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1 && this.salerData.belongToSmb) {
        callback(new Error(`${this.$t('newApp.activityInfo.psacn')}`));
      } else {
        callback();
      }
    };
    let businessUnitMessage = (rule, value, callback) => {
      if (value.length < 1 && this.salerData.belongToQyw && this.unitNameList.length > 0) {
        callback(new Error(`${this.$t('newApp.activityInfo.psabu')}`));
      } else {
        callback();
      }
    };
    let relatedActivityCodeMessage = (rule, value, callback) => {
      if (!value && this.relationActivityRequired) {
        callback(new Error(`${this.$t('newApp.activityInfo.pstaacn')}`));
      } else {
        callback();
      }
    };
    let dateValidator = (rule, value, callback) => {
      if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error(`${this.$t('newApp.activityInfo.tsdcbgtted')}`));
      } else {
        this.$refs.activityInfoForm.clearValidate(['expectStartDate', 'expectEndDate']);
        callback();
      }
    };
    let productlineValidator = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.productlineOtherShow && !this.formData.productlineOther) {
          callback(new Error(`${this.$t('newApp.activityInfo.pepl')}`));
        } else {
          callback();
        }
      });
    };
    let plateValidator = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.plateOtherShow && !this.formData.plateOther) {
          callback(new Error(`${this.$t('newApp.activityInfo.peteis')}`));
        } else {
          callback();
        }
      });
    };
    return {
      rules: {
        budgetAmount: [
          { required: true, message: `${this.$t('newApp.activityInfo.peba')}`, trigger: 'blur' }
        ],
        organizerReason: [
          { required: true, message: `${this.$t('newApp.activityInfo.petrfa')}`, trigger: 'blur' }
        ],
        businessUnitDisplayed: [
          { validator: businessUnitMessage, trigger: 'change' }
        ],
        activityName: [
          { required: true, message: `${this.$t('newApp.activityInfo.peen')}`, trigger: 'blur' }
        ],
        activityClassificationCode: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaac')}`, trigger: 'change' }
        ],
        targetObject: [
          { required: true, message: `${this.$t('newApp.activityInfo.pstmt')}`, trigger: 'change' }
        ],
        // organizer: [
        //   { required: true, message: `${this.$t('newApp.activityInfo.psao')}`, trigger: 'change' }
        // ],
        city: [
          { required: true, message: `${this.$t('newApp.activityInfo.pehc')}`, trigger: 'blur' }
        ],
        activityTypeCode: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaet')}`, trigger: 'change' }
        ],
        qdMeetingSegment: [
          { required: true, message: `${this.$t('newApp.activityInfo.psacms')}`, trigger: 'change' }
        ],
        activityBaseName: [
          { required: true, message: `${this.$t('newApp.activityInfo.pshdjd')}`, trigger: 'change' }
        ],
        activityBaseContactInformation: [
          { required: true, message: `${this.$t('newApp.activityInfo.psjdlx')}`, trigger: 'blur' }
        ],
        activityForms: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaef')}`, trigger: 'change' }
        ],
        unionChannelType: [
          { validator: unionChannelTypeMessage, trigger: 'change' }
        ],
        unionChannelName: [
          { validator: unionChannelNameMessage, trigger: 'change' }
        ],
        inviterNum: [
          { required: true, message: `${this.$t('newApp.activityInfo.pettnop')}`, trigger: 'blur' }
        ],
        expectStartDate: [
          { required: true, message: `${this.$t('newApp.activityInfo.psasd')}`, trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaed')}`, trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        relatedActivityCode: [
          { validator: relatedActivityCodeMessage, trigger: 'change' }
        ],
        plateView: [
          { required: true, message: `${this.$t('newApp.activityInfo.teietcs')}`, trigger: 'change' },
          { validator: plateValidator, trigger: 'change' }
        ],
        productlineSupplement: [
          { required: true, message: `${this.$t('newApp.activityInfo.psapl')}`, trigger: 'change' },
          { validator: productlineValidator, trigger: 'change' }
        ],
        communicationScenarioList: [
          { required: true, message: `${this.$t('newApp.activityInfo.Psstrpr')}`, trigger: 'change' }
        ],
        agendaShow: [
          { required: true, message: `${this.$t('newApp.activityInfo.Psagenda')}`, trigger: 'change' }
        ],
        remotePoc: [
          { required: true, message: `${this.$t('newApp.activityInfo.perp')}`, trigger: 'blur' }
        ],
        unitedDiamondActivity: [
          { required: true, message: `${this.$t('newApp.activityInfo.pejda')}`, trigger: 'blur' }
        ],
        circleActivity: [
          { required: true, message: `${this.$t('newApp.activityInfo.peca')}`, trigger: 'blur' }
        ],
        templateVisit: [
          { required: true, message: `${this.$t('newApp.activityInfo.peastv')}`, trigger: 'blur' }
        ],
        machineDemo: [
          { required: true, message: `${this.$t('newApp.activityInfo.psMachineDemo')}`, trigger: 'blur' }
        ],
        // 营销形式
        marketingForm: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.yxxs')}`, trigger: 'change' }
        ],
        // 主办方
        organizer: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.zbf')}`, trigger: 'blur' }
        ],
        // 邀请方
        invitingParty: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.yqf')}`, trigger: 'change' }
        ],
        // 品牌支持
        brandPromotionSupport: [
          { required: true, message: `${this.$t('newApp.activityInfo.psps')}`, trigger: 'change' }
        ],
        // 关键市场
        keyMarket: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.gjsc')}`, trigger: 'blur' }
        ],
        // 举办城市
        isNationalRelease: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.mxqgfb')}`, trigger: 'change' }
        ],
        // 面向行业
        targetIndustry: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.mxhy')}`, trigger: 'change' }
        ],
        // 预计举办周期
        targetCoverageCustomerPortrait: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.mbfgghhx')}`, trigger: 'blur' }
        ],
        // 预计活动时长
        expectedDurationOfTheEvent: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.yqjbzq')}`, trigger: 'change' }
        ],
        activityBackgroundPurpose: [
          { required: true, message: `${this.$t('industryReport.hdxxtsy.hdbjmd')}`, trigger: 'blur' }
        ]
      },
      marketingFormList: [{
        fieldKey: '1',
        fieldValue: '市场活动'
      }, {
        fieldKey: '2',
        fieldValue: '数字营销(内容营销)'
      }], // 营销形式列表
      invitingPartyList: [
        {
          fieldKey: '2',
          fieldValue: '行业自主邀请'
        },
        {
          fieldKey: '1',
          fieldValue: '区域邀请'
        }
      ], // 邀请方
      isNationalReleaseList: [
        {
          fieldKey: '1',
          fieldValue: '是'
        },
        {
          fieldKey: '0',
          fieldValue: '否'
        }
      ], // 是否面向全国发布
      targetIndustryList: [], // 面向行业
      targetObjectList: [], // 主要目标对象列表
      brandPromotionSupporList: [], // 品推支持
      organizerList: [], // 主办方列表
      activityClassificationList: [], // 活动分类
      activityFormsList: [], // 活动形式
      productlineSupplementList: [], // 活动内容涉及产品线
      relationActivityList: [], // 关联活动分类列表
      activityTypeList: [], // 活动类型列表
      activityLevelList: [],
      qdMeetingSegmentList: [], // 渠道会议细分列表
      unionChannelTypeList: [], // 签约渠道类型列表
      unionChannelNameList: [], // 渠道名称列表,
      unitNameList: [], // 业务单元列表
      plateList: [], // 活动预计包含板块列表
      comscValue: '',
      fbCommunicationScenario: [], // 交流场景列表
      fbCommunicationScenarioOld: [], // 原交流场景列表
      fbCommunicationScenarioNew: [], // 战略产品列表
      agendaList: [], // 活动议程列表
      sourceLink: '',
      formData: {
        cruxCheckbox: [],
        plateView: [],
        marketingForm: '', // 营销形式
        productlineSupplement: [],
        businessUnitDisplayed: [],
        mactCommunicationScenarioList: [],
        mactAgendaList: [],
        agendaShow: [],
        activityBackgroundPurpose: '',
        isUnionMarket: 0,
        isInternationalQd: 0,
        needOrganizer: 0,
        isBatchApprove: null,
        activityName: '', // 活动名称
        activityClassificationCode: '', // 活动分类
        activityForms: '', // 活动形式
        organizer: '', // 主办方
        targetObject: '', // 主要目标对象
        targetObjectOther: '', // 主要目标对象-其它内容
        targetCoverageCustomerPortrait: '', // 目标覆盖客户画像
        invitingParty: '', // 邀请方
        keyMarket: '', // 关键市场
        city: '', // 举办城市
        isNationalRelease: '', // 是否面向全国发布
        targetIndustry: '', // 面向行业
        expectedDurationOfTheEvent: [], // 预计举办周期
        communicationScenarioList: [], // 战略产品
        machineDemo: '', // 样机演示/体验
        templateVisit: '', // 样板参观
        circleActivity: '' // 圈子活动

      },
      plateOtherShow: false, // 活动预计包含板块'其他'显隐
      relationActivityName: '关联活动名称:',
      relationActivityShow: false, // 关联活动是否显示
      relationActivityRequired: false, // 关联活动是否必填
      productlineOtherShow: false,
      needOrganizerShow: false, // 是否需要活动组支持显隐
      organizerReasonShow: false, // 需要活动组理由显隐
      isReadOnly: false, // 只读模式
      unionChannelLoading: false, // 渠道名称loading
      agendaStatus: false, // 活动议程显隐
      isEditable: 0,
      cruxCheckboxList: [
        {
          key: 'remotePoc',
          name: '远程POC',
          value: 'rp',
          disabled: () => {
            return this.lang !== 'zh-CN' || (this.lang === 'zh-CN' && this.formData.activityClassificationCode === 'AC_06');
          }
        },
        {
          key: 'unitedDiamondActivity',
          name: '联合精钻活动',
          value: 'jra',
          disabled: () => {
            return this.lang !== 'zh-CN' || (this.lang === 'zh-CN' && this.formData.activityClassificationCode === 'AC_06');
          }
        },
        {
          key: 'circleActivity',
          name: '圈子活动',
          value: 'ca',
          disabled: () => {
            return true;
          }
        },
        {
          key: 'templateVisit',
          name: '样板参观',
          value: 'mv',
          disabled: () => {
            return true;
          }
        },
        {
          key: 'machineDemo',
          name: '样机演示/体验',
          value: 'machineDemo',
          disabled: () => {
            return true;
          }
        }
      ],
      activityBaseList: [],
      lang: localStorage.getItem('lang') || 'zh-CN',
      belongToSbg: false, // 是否是sbg部门
      smbStatus: false,
      salerDeptCode: [],
      pickerOptions: {
        disabledDate (time) {
          // 以当天 00:00 为界，禁止选择今天之前的日期
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      }
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    componentName: {
      type: String,
      default: ''
    },
    setCacheList: {
      type: Function,
      default: () => {
        return {};
      }
    },
    updateForm: {
      type: Function,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      salerData: (state) => state.newApplication.salerData
    }),
    isPtShow () {
      // 活动分类不为行业模板-品推支持显示 | 数字营销-品推支持显示
      const { marketingForm, activityClassificationCode } = this.formData;
      const codeList = ['AC_02', 'AC_03', 'AC_06'];
      return marketingForm === '2' || (marketingForm === '1' && codeList.includes(activityClassificationCode));
    }
  },
  watch: {
    salerData: {
      immediate: true,
      deep: true,
      handler (data) {
        if (isNotEmpty(data.deptCode)) {
          this.salerDeptCode = data.deptCode;
          this.getActivityBaseList(data.deptCode);
          this.getActivityList(data.deptCode);
          this.getActivityTypeList('全部', data.deptCode);
          if (data.deptCode.startsWith('000063')) {
                this.belongToSbg = true;
                this.$set(this.formData, 'activityLevel', '');
            } else {
              this.belongToSbg = false;
              if (!this.formData.activityLevel) {
                  this.$set(this.formData, 'activityLevel', 'B');
              }
          }
        }
        if (this.$store.state.newApplication.salerLoadFlag) return;
        // 清空业务单元
        this.formData.businessUnitDisplayed = [];
        this.unitNameList = [];
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['businessUnitDisplayed']);
        });
        this.getUnitNameList(data.deptCode);
      }
    },
    editEchoData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        if (isNotEmpty(newVal) && isNotEmpty(newVal.mactExpenseBelongVOList)) {
          this.smbStatus = newVal.mactExpenseBelongVOList.some(item => item.mactExpenseBelong.expenseTypeCode === 'EI172');
          this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
          this.$store.commit('newApplication/setIsUnionMarket', 1);
        } else {
          this.smbStatus = false;
          this.$store.commit('newApplication/setIsUnionMarket', 0);
        }
      }
    }
  },
  created () {
    bus.$on('activeType', (list) => {
      if (isNotEmpty(list)) {
        this.smbStatus = list.some(item => item.expenseTypeCode === 'EI172');
        this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
        this.$store.commit('newApplication/setIsUnionMarket', 1);
      } else {
        this.smbStatus = false;
        this.$store.commit('newApplication/setIsUnionMarket', 0);
      }
    });
  },
  destroyed () {
    // 组件销毁前需要解绑事件。否则会出现重复触发事件的问题
    bus.$off('activeType');
  },
  methods: {
    targetObjectChange () {
      if (!this.isTargetObjectOther) {
        this.$set(this.formData, 'targetObjectOther', '');
      }
    },
    goToLook () {
      window.open('https://ruijie.feishu.cn/share/base/query/shrcnLYaqtH3GcUGNq84cJclTTd');
    },
    // 预计举办周期
    handleDateChange (val) {
      if (val) {
        this.$set(this.formData, 'expectStartDate', val[0]);
        this.$set(this.formData, 'expectEndDate', val[1]);
      } else {
        this.$set(this.formData, 'expectStartDate', '');
        this.$set(this.formData, 'expectEndDate', '');
      }
    },
    marketingFormChange () {
      // 营销形式变化，活动分类清空
      if (this.formData.marketingForm === '2') {
        this.$set(this.formData, 'activityClassificationCode', '');
        this.$set(this.formData, 'activityClassification', '');
        this.$set(this.formData, 'activityBackgroundPurpose', ''); // 活动背景&目的
        this.$emit('activityClassificationChange', ''); // 触发活动分类change事件
      }
      this.$store.commit('newApplication/setActivityClassification', '');
      // 活动名称显示变化
      this.rules.activityName[0].message = this.formData.marketingForm === '2' ? `${this.$t('industryReport.hdxxtsy.yxzt')}` : `${this.$t('newApp.activityInfo.peen')}`;
      this.keyAttendeesChange();
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate();
      });
    },
    // 营销形式 && 是否面向全国变化 =》 重点参会落地区域
    keyAttendeesChange () {
      const params = {
        marketingForm: this.formData.marketingForm,
        isNationalRelease: this.formData.isNationalRelease
      };
      this.$emit('keyAttendeesChange', params);
    },
    getActivityBaseList (deptCode) {
      const params = {
        deptCode
      };
      activityBaseApi.getConfigActivityBaseList(params).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            this.activityBaseList = [{ name: '不使用', id: 'nonUseId' }, ...res.data];
            if (!this.$route.query.activityCode || (this.$route.query.activityCode && !this.formData.activityBaseName)) {
              this.$set(this.formData, 'activityBaseName', '不使用');
            }
          } else {
            this.activityBaseList = [];
          }
        }
      });
    },
    activityFileCommand () {
      this.activityBaseList.forEach(item => {
        if (item.imageUrl) {
          newApplicationFormApi.getFileToken().then(res => {
            if (res.status === '200') {
              const Token = res.data;
              this.$set(item, 'file', `${window._env_.VUE_APP_FILEOPEN_URL}/${item.imageUrl}?Token=${Token}`);
            }
          });
        }
      });
    },
    activityBaseNameChange (e) {
      const currentData = this.activityBaseList.find(item => item.name === e);
      this.$set(this.formData, 'activityBaseContactInformation', currentData.contactInformation);
      this.$set(this.formData, 'activityBaseUrl', currentData.imageUrl);
      this.$set(this.formData, 'activityBaseDeptCode', currentData.deptCode);
    },
    organizerChange (val) {
      this.$set(this.formData, 'activityTypeCode', '');
      this.formData.activityType = '';
      this.activityTypeList = [];
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['activityTypeCode']);
      });
      // let params = this.$t('newApp.activityInfo.ht');
      let params = '主办型';
      if (val === this.$t('newApp.activityInfo.atomc')) {
        // params = this.$t('newApp.activityInfo.pt');
        params = '参与型';
      }
      this.getActivityTypeList(params, this.salerDeptCode);
    },
    getActivityTypeList (params, deptCode) {
      if (params !== '参与型' && (deptCode.startsWith('000063650007') || deptCode.startsWith('000063657'))) {
          let params = ['smb_international_activity_type'];
          newApplicationFormApi.getActivityList(params).then(res => {
              if (res.status === '200') {
              let { data } = res;
                this.activityTypeList = data.smb_international_activity_type;
              }
            });
        } else {
            newApplicationFormApi.getActivityTypeList(params).then(res => {
            if (res.status === '200') {
              this.activityTypeList = res.data;
            }
        });
      }
    },
    cruxCheckboxChange () {
      // 如果取消选中项，则清空对应的输入框
      this.cruxCheckboxList.forEach(item => {
        if (this.formData.cruxCheckbox.indexOf(item.key) < 0) {
          this.$set(this.formData, item.key, '');
        }
      });
    },
    brandPromotionSupportChange (val) {
      let obj = arrayQuery(val, this.brandPromotionSupporList, 'fieldValue');
      this.formData.brandPromotionSupportKey = obj.fieldKey;
    },
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['activityInfoForm'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    activityTypeChange (val) {
      // 获取活动类型名称
      this.formData.activityType = arrayQuery(val, this.activityTypeList, 'fieldKey').fieldValue;
      // 清除相关联字段
      this.qdMeetingSegmentClear();
    },
    relatedActivityChange (val) {
      let obj = arrayQuery(val, this.relationActivityList, 'code');
      this.formData.relatedActivityName = obj.text;
      this.formData.isBatchApprove = obj.isBatchApprove;
      this.formData.sourceLink = obj.sourceLink;
      if (this.relationActivityName === this.$t('home.ha') && isNotEmpty(obj)) {
        this.$set(this.formData, 'hqAcitvityCode', obj.code);
        this.$set(this.formData, 'hqActivityName', obj.text);
      } else {
        this.$set(this.formData, 'hqActivityCode', '');
        this.$set(this.formData, 'hqActivityName', '');
      }
      // 区域模块活动不关联活动名称
      if (this.formData.activityClassificationCode !== 'AC_01') {
        this.$set(this.formData, 'activityName', obj.text);
        this.agendaStatus = false;
      } else {
        this.agendaStatus = true;
        if (val) {
          this.getTemplateActivityAgendaCommand(val);
        }
      }
    },
    downloadCommand () {
      window.open(this.sourceLink);
    },
    getTemplateActivityAgendaCommand (val) {
      const currentInfo = this.relationActivityList.find(item => item.code === val);
      this.sourceLink = currentInfo.sourceLink;
      newApplicationFormApi.getTemplateActivityAgenda(val).then(res => {
        if (res.status === '200') {
          this.agendaList = res.data;
          if (!this.$route.query.activityCode) {
            this.formData.mactAgendaList = [];
            this.formData.agendaShow = [];
            res.data.forEach(item => {
              this.formData.mactAgendaList.push({
                agendaName: item.agenda,
                agendaCode: item.orderNum
              });
              this.formData.agendaShow.push(item.agenda);
            });
          }
        }
      });
    },
    agendaListChange (e) {
      this.formData.mactAgendaList = [];
      this.agendaList.forEach(item => {
        e.forEach(ite => {
          if (item.agenda === ite) {
            const index = this.formData.mactAgendaList.findIndex(iteIndex => iteIndex.agendaName === ite);
            if (index === -1) {
              this.formData.mactAgendaList.push({
                agendaName: item.agenda,
                agendaCode: item.orderNum
              });
            }
          }
        });
      });
    },
    plateOtherChange (val) {
      this.plateOtherShow = val.some(item => {
        return item === '10';
      });
    },
    qdMeetingSegmentClear () {
      this.$set(this.formData, 'qdMeetingSegment', '');
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['qdMeetingSegment']);
      });
    },
    budgetAmountChange (val) {
      let newVal = val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');
      this.$set(this.formData, 'budgetAmount', newVal);
    },
    needOrganizerChange (val) {
      this.$set(this.formData, 'budgetAmount', null);
      this.$set(this.formData, 'organizerReason', '');
      this.$store.commit('newApplication/setNeedOrganizer', val);
    },
    unionChannelNameChange (val) {
      this.$store.commit('newApplication/setIsUnionMarket', val);
    },
    unionChannelTypeChange () {
      this.unionChannelNameList = [];
      this.$set(this.formData, 'unionChannelName', '');
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['unionChannelName']);
      });
    },
    unionChannelRemote (query) {
      if (!this.formData.unionChannelType) {
        this.$message.error(this.$t('newApp.activityInfo.pscst'));
        return;
      }
      if (query !== '') {
        let params = {
          partnerType: this.formData.unionChannelType,
          companyName: query
        };
        this.getChannelNameList(params);
      } else {
        this.unionChannelNameList = [];
      }
    },
    inviterNumFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
      this.$set(this.formData, 'inviterNum', numVal);
    },
    getRelevanceActivityList (val) {
      let params = 'NEW';
      // 根据值获取关联活动的列表
      if (val === 'AC_03' || val === 'AC_06') {
        this.agendaStatus = false;
        // 区域参加总部活动、总部重点活动
        this.relationActivityName = this.$t('home.ha');
        this.$set(this.formData, 'relatedActivityCode', this.formData.hqActivityCode);
        this.$set(this.formData, 'relatedActivityName', this.formData.hqActivityName);
        newApplicationFormApi.getHeadquarterActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.activityName,
              isBatchApprove: item.isBatchApprove
            };
          });
        });
      } else if (val === 'AC_01') {
        this.agendaStatus = true;
        // 区域模板活动
        this.relationActivityName = this.$t('newApp.activityInfo.ta');
        newApplicationFormApi.getTemplateActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.templateName,
              activityType: item.activityType,
              activityTypeCode: item.activityTypeCode,
              activitySubType: item.activitySubType,
              activityGoal: item.activityGoal,
              sourceLink: item.sourceLink ? item.sourceLink : ''
            };
          });
          const currentInfo = this.relationActivityList.find(item => item.code === this.formData.relatedActivityCode);
          if (isNotEmpty(currentInfo)) {
            this.sourceLink = currentInfo.sourceLink;
          }
          if (this.formData.relatedActivityCode) {
            this.getTemplateActivityAgendaCommand(this.formData.relatedActivityCode);
          }
        });
      } else {
        this.agendaStatus = false;
        this.relationActivityShow = false;
      }
      // 控制是否需要活动组支持显隐
      if (val === 'AC_06') {
        this.needOrganizerShow = true;
      }
      // 将数据提交到父级关联使用
      this.setCacheList('activityClassificationCode', val);
    },
    activityClassificationCodeChange (val) {
      // 获取对应的活动分类名称
      this.formData.activityClassification = arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;

      this.relationActivityShow = true;
      if (val === 'AC_06' || val === 'AC_02') {
        // 如果选择总部活动 || 区域活动，则关联活动不必填
        this.relationActivityRequired = false;
      } else {
        this.relationActivityRequired = true;
      }
      this.$set(this.formData, 'relatedActivityCode', '');
      this.formData.relatedActivityName = '';
      this.relationActivityList = [];
      this.needOrganizerShow = false;
      // 如果选择了总部活动,隐藏品推支持字段
      if (val === 'AC_01') {
        this.$set(this.formData, 'brandPromotionSupport', ''); // 主办方选项清空
        this.$set(this.formData, 'invitingParty', '1'); // 邀请方强制 区域邀请
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['brandPromotionSupport']);
        });
      }

      // 如果选择区域参与总部活动
      if (val === 'AC_03') {
        this.$set(this.formData, 'organizer', ''); // 主办方选项清空
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['organizer']);
        });
      }

      this.$set(this.formData, 'needOrganizer', 0); // 是否需要活动组支持清除
      this.needOrganizerChange(0); // 触发活动组支持change方法

      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['relatedActivityCode']);
      });

      this.$store.commit('newApplication/setActivityClassificationLoadFlag', 0);
      this.$store.commit('newApplication/setActivityClassification', val);
      if (val !== 'AC_01') {
        this.agendaList = [];
        this.formData.agendaShow = [];
        this.formData.mactAgendaList = [];
      }
      this.$emit('activityClassificationChange', val); // 触发活动分类change事件
      this.getRelevanceActivityList(val);
      for (let i = this.cruxCheckboxList.length - 1; i >= 0; i--) {
        const item = this.cruxCheckboxList[i];
        if (this.formData.cruxCheckbox.includes(item.key)) {
          this.formData.cruxCheckbox.splice(this.formData.cruxCheckbox.indexOf(item.key), 1);
        }
      }
      this.$set(this.formData, 'plateView', []);
      this.$set(this.formData, 'cruxCheckbox', []);
    },
    isUnionMarketChange (val) {
      if (val === 0) {
        this.unionChannelClear();
      }
      this.unionChannelNameChange(val);
    },
    unionChannelClear () {
      this.$set(this.formData, 'unionChannelType', '');
      this.$set(this.formData, 'unionChannelName', '');
      this.unionChannelNameList = [];
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['unionChannelType', 'unionChannelName']);
      });
    },
    isInternationalQdChange (val) {
      this.getChannelTypeList(val);
      this.unionChannelClear();
    },
    expectStartDateChange (val) {
      let future = new Date(val).getTime();
      let current = new Date().getTime();
      let fifteenDays = 15 * 24 * 60 * 60 * 1000;
      this.organizerReasonShow = future < (current + fifteenDays);
    },
    productlineSupplementChange (e) {
      const { activityCode } = this.$store.state.newApplication;
      const eventCode = this.$route.query.activityCode || activityCode;
      this.formData.mactCommunicationScenarioList = [];
      this.fbCommunicationScenario.forEach(item => {
        e.forEach(ite => {
          if (item.fieldValue === ite) {
            const index = this.formData.mactCommunicationScenarioList.findIndex(iteIndex => iteIndex.communicationScenarioName === ite);
            if (index === -1) {
              this.formData.mactCommunicationScenarioList.push({
                activityCode: eventCode,
                communicationScenarioName: item.fieldValue,
                communicationScenarioCode: item.fieldKey,
                reportType: 0
              });
            }
          }
        });
      });
    },
    productlineSupplementFilter () {
      return this.$refs.productLineSelectRef.productlineSupplementFilter();
    },
    plateFilter () {
      let returnVal = [];
      for (let i = 0; i < this.formData.plateView.length; i++) {
        this.plateList.forEach(item => {
          if (item.fieldKey === this.formData.plateView[i]) {
            returnVal.push({
              moduleCode: item.fieldKey,
              moduleName: item.fieldKey === '10' ? this.formData.plateOther : item.fieldValue
            });
          }
        });
      }
      return returnVal;
    },
    getUnitNameList (code) {
      newApplicationFormApi.getUnitNameList(code).then(res => {
        if (res.status === '200') {
          this.unitNameList = res.data;
        }
      });
    },
    getActivityList (code) {
      // 主办方--organizer
      // 渠道会议细分--qd_meeting_segment
      // 目标对象--target_object
      // 预计板块--plate

      let params = [
        'plate', // 预计板块
        'qd_meeting_segment', // 渠道会议细分
        'organizer', // 主办方
        'target_object', // 目标对象
        'union_market_help', // 联合市场支持
        'activity_forms', // 活动形式
        'activity_classification', // 活动分类
        'productline_supplement', // 产品线
        'expense_detail_item', // 费用明细项
        'brand_promotion_suppor', // 品推支持
        'fb_communication_scenario', // 战略产品
        'activity_level', // 活动等级
        'report_industry' // 面向行业
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.plateList = data.plate;
          this.qdMeetingSegmentList = data.qd_meeting_segment;
          this.organizerList = data.organizer;
          this.targetObjectList = data.target_object;
          this.activityFormsList = data.activity_forms;
          this.productlineSupplementList = data.productline_supplement;
          this.brandPromotionSupporList = data.brand_promotion_suppor;
          this.targetIndustryList = data.report_industry;
          this.fbCommunicationScenarioNew = data.fbCommunicationScenario.filter(item => item.flag);
          this.fbCommunicationScenarioOld = data.fbCommunicationScenario.filter(item => !item.flag);
          if (this.$route.path !== '/editApplication') {
            this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            const { mactCommunicationScenarioList } = this.editEchoData;
            if (isNotEmpty(mactCommunicationScenarioList)) {
              const index = this.fbCommunicationScenarioNew.findIndex(item => item.fieldKey === mactCommunicationScenarioList[0].communicationScenarioCode);
              if (index !== -1) {
                this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
                this.comscValue = this.$t('newApp.activityInfo.strpr');
              } else {
                this.fbCommunicationScenario = this.fbCommunicationScenarioOld;
                this.comscValue = this.$t('newApp.activityInfo.comsc');
              }
            } else {
              this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
              this.comscValue = this.$t('newApp.activityInfo.strpr');
            }
          }
          this.activityLevelList = data.activity_level;
          // 活动分类处理
           // 对应销售为平台管理部时候不可以看到总部活动
          const isPlatformDept = code.startsWith('000062692');
          this.activityClassificationList = data.activity_classification.filter(item => {
            return item.fieldKey !== 'AC_02' && item.fieldKey !== 'AC_03';
          });
          // 如果是报备路径或平台管理部，则过滤掉总部活动(AC_06)
          if (isPlatformDept) {
            this.activityClassificationList = this.activityClassificationList.filter(item => {
              return item.fieldKey !== 'AC_06';
            });
          }
        }
      });
    },
    getChannelTypeList (internationalFlag) {
      let params = internationalFlag ? 1 : 0;
      newApplicationFormApi.getChannelTypeList(params).then(res => {
        if (res.status === '200') {
          if (params) {
            this.unionChannelTypeList = res.data;
            return;
          }
          this.unionChannelTypeList = res.data.filter(item => {
            return item.deptType === 'smb';
          });
        }
      });
    },
    getChannelNameList (params) {
      this.unionChannelLoading = true;
      let interfaceFun = this.formData.isInternationalQd ? newApplicationFormApi.getInternationalNameList(params) : newApplicationFormApi.getChannelNameList(params);
      interfaceFun.then(res => {
        if (res.status === '200') {
          this.unionChannelNameList = res.data;
        }
        this.unionChannelLoading = false;
      });
    }
  },
  mounted () {
    if (this.lang !== 'zh-CN') {
      this.cruxCheckboxList.splice(2, 1);
    };
    let userInfo = this.$store.state.userInfo;
    // 编辑处理
    if (this.$route.query.activityCode) {
      // 如果是转申请页或者报备编辑页就全部禁止操作
      if (this.$route.path === '/industryReportTransferApplication') {
        this.isReadOnly = true;
      }
      // 3：表示只能编辑费用归属
      if (this.$store.state.newApplication.editFlag === 3) {
        this.isReadOnly = true;
      }
      // 驳回编辑可以修改
      if (this.$route.path === '/editIndustryReportApplication') {
        this.isReadOnly = false;
      }
      // 编辑回显
      this.formData = {
        ...this.formData,
        ...this.editEchoData.marketActivityExpand,
        ...this.editEchoData.marketActivity
      };

      // 如果禁用了，过滤出展示信息
      if (this.isReadOnly) {
        // 活动预计板块
        if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
          this.formData.mactModuleView = this.editEchoData.mactModuleList.map(item => {
            return item.moduleName;
          }).join('，');
        }
      }
      // 活动类型处理
      let activityTypeParams = '全部';
      if (this.formData.organizer) {
        activityTypeParams = this.$t('newApp.activityInfo.ht');
        if (this.formData.organizer === this.$t('newApp.activityInfo.atomc')) {
          activityTypeParams = this.$t('newApp.activityInfo.pt');
        }
      }
      this.getActivityTypeList(activityTypeParams, this.formData.salerDeptCode);
      // 申请理由处理
      this.expectStartDateChange(this.formData.expectStartDate);
      // 获取业务单元列表
      if (this.formData.salerDeptCode) {
        this.getUnitNameList(this.formData.salerDeptCode);
      }
      // 业务单元回显处理
      if (this.formData.businessUnit && this.formData.businessUnit.length > 0) {
        this.formData.businessUnitDisplayed = this.formData.businessUnit.split(',');
      }
      // 活动分类回显处理
      if (this.formData.activityClassificationCode) {
        this.relationActivityShow = true;
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 1);
        this.$store.commit('newApplication/setActivityClassification', this.formData.activityClassificationCode);
        // 如果选择总部活动，则关联活动不必填
        if (this.formData.activityClassificationCode === 'AC_06' || this.formData.activityClassificationCode === 'AC_02') {
          this.relationActivityRequired = false;
        } else {
          this.relationActivityRequired = true;
        }
        this.getRelevanceActivityList(this.formData.activityClassificationCode);
      }
      // 联合市场活动处理
      if (this.formData.isUnionMarket) {
        this.$store.commit('newApplication/setIsUnionMarket', this.formData.isUnionMarket);
      }
      // 修改回显字段类型
      // 营销形式
      if (this.formData.marketingForm) {
        this.formData.marketingForm = this.formData.marketingForm.toString();
      }
      // 邀请方
      if (this.formData.invitingParty) {
        this.formData.invitingParty = this.formData.invitingParty.toString();
      }
      // 是否面向全国发布
      if (this.formData.isNationalRelease || this.formData.isNationalRelease === 0) {
        this.formData.isNationalRelease = this.formData.isNationalRelease.toString();
      }
      // 预计举办周期
      if (this.formData.expectStartDate && this.formData.expectEndDate) {
        this.formData.expectedDurationOfTheEvent = [this.formData.expectStartDate, this.formData.expectEndDate];
      }
      // 面向行业
      if (this.formData.targetIndustry) {
        this.formData.targetIndustry = this.formData.targetIndustry.toString();
      }
      // 关键举措回显处理
      this.cruxCheckboxList.forEach(item => {
        if (this.formData[item.key]) {
          this.formData.cruxCheckbox.push(item.key);
        }
      });

      // 产品线回显处理
      if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
        this.$nextTick(() => {
          const result = this.$refs.productLineSelectRef.initFromEchoData(
            this.editEchoData.mactProductLineList
          );
          if (this.isReadOnly) {
            this.$set(this.formData, 'productlineView', result.productlineView);
          }
        });
      }
      // 活动预计包含板块回显处理
      if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
        this.formData.plateView = this.editEchoData.mactModuleList.map(item => {
          if (item.moduleCode === '10') {
            this.plateOtherShow = true;
            this.$set(this.formData, 'plateOther', item.moduleName);
          }
          return item.moduleCode;
        });
      }
      if (isNotEmpty(this.editEchoData.mactCommunicationScenarioList)) {
        this.formData.communicationScenarioList = this.editEchoData.mactCommunicationScenarioList.map(item => {
          return item.communicationScenarioName;
        });
        this.$set(this.formData, 'mactCommunicationScenarioList', this.editEchoData.mactCommunicationScenarioList);
      }
      if (isNotEmpty(this.editEchoData.mactAgendaList)) {
        this.formData.agendaShow = this.editEchoData.mactAgendaList.map(item => {
          return item.agendaName;
        });
        this.$set(this.formData, 'mactAgendaList', this.editEchoData.mactAgendaList);
      }
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate();
      });
    } else {
      // 新增数据初始化
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;

      this.getUnitNameList(userInfo.sysUser.deptCode);
      this.getActivityTypeList('全部', userInfo.sysUser.deptCode);
      this.getActivityList(userInfo.sysUser.deptCode); // 获取[活动分类,活动目的,活动形式,产品线]列表
    }
    this.getChannelTypeList(this.formData.isInternationalQd); // 获取渠道签约类型列表
  }
};
</script>

<style lang="scss">
.basicInformation {
  .specialRequired textarea {
    min-height: 70px !important;
  }

  .cruxCustomStyle {
    padding: 10px;

    &.borderStyle {
      border-bottom: 1px solid #dee1e7;
    }
  }
}
.active-text{
  color:#14937b;
  cursor: pointer;
}
</style>
